import { css } from "@emotion/css";
import { ActionButton, FileUpload } from "@octopusdeploy/design-system-components";
import { space } from "@octopusdeploy/design-system-tokens";
import { useInlineStatusQuery } from "@octopusdeploy/octopus-react-client";
import type { ActivityElement } from "@octopusdeploy/octopus-server-client";
import { TaskState } from "@octopusdeploy/octopus-server-client";
import { noOp } from "@octopusdeploy/utilities";
import { useState } from "react";
import { activityElementUniqueIdFromId } from "~/areas/tasks/components/Task/TaskLog/TaskLogUtil";
import type { UniqueActivityElement } from "~/components/TaskLogLines/TaskLogBlock";
import TaskLogBlock from "~/components/TaskLogLines/TaskLogBlock";
export const TaskLogViewer = () => {
    const [files, setFiles] = useState<File[]>([]);
    const [expandedIds, setExpandedIds] = useState<string[]>([]);
    const { result: taskLogElements, isLoading } = useInlineStatusQuery(async (repository) => {
        if (files.length > 0) {
            const parseTaskLogsResponse = await repository.Diagnostics.parseTaskLogs(files);
            return parseTaskLogsResponse.TaskLogs;
        }
        else {
            return Promise.resolve([]);
        }
    }, [files], "Parse task logs");
    const setIdPrefix = (ele: ActivityElement, n: number): UniqueActivityElement => {
        return {
            ...ele,
            uniqueId: activityElementUniqueIdFromId(ele.Id, n),
            Children: ele.Children ? ele.Children.map((c) => setIdPrefix(c, n)) : [],
        };
    };
    const uniqueElements = taskLogElements ? taskLogElements.map((e, i) => setIdPrefix(e, i)) : [];
    const reset = () => {
        setFiles([]);
    };
    return (<div className={styles.container}>
            {files.length > 0 ? (<>
                    <div className={styles.actions}>
                        <ActionButton label="Reset" onClick={reset}/>
                    </div>
                    {!isLoading && uniqueElements.length === 0 && <span>No task logs found in the selected files</span>}
                    {uniqueElements.map((e) => (<TaskLogBlock key={e.uniqueId} element={e} taskState={TaskState.Success} collapsible={true} expandedIds={expandedIds} focusId={undefined} showRunTime={true} showTimestamps={true} parentDuration={0} setExpanded={(id, expanded) => setExpandedIds((prev) => (expanded ? [...prev, id] : prev.filter((v) => v !== id)))} onFetchRange={noOp} isFetchDisabled={true}/>))}
                </>) : (<FileUpload filesLimit={10} label={"Drag and drop task log files or select to browse (max limit of 10)"} onChange={(files) => setFiles(files)}/>)}
        </div>);
};
const styles = {
    container: css({
        padding: space[16],
    }),
    actions: css({
        display: "flex",
        justifyContent: "flex-end",
    }),
};
